module.exports = __webpack_public_path__ + "img/Set spend limit.4822f216.svg";